<template>
  <button
    type="button"
    class="button"
    @click="$emit('click', $event)"
  >
    <icon-close class="button__icon"/>
  </button>
</template>

<script>
import IconClose from '@/mikan/_shared/components/atoms/icons/IconClose.vue';

export default {
  components: {
    IconClose,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/pc/base/constants';

.button {
  display: flex;
  width: px-to-em(16px);
  height: px-to-em(16px);
  align-items: center;
  justify-content: center;
  background-color: transparent;

  &:hover {
    cursor: pointer;
  }

  &__icon {
    flex: 0 0 auto;
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }
}
</style>
